import useEqualHeights from 'components/subjectSite/useEqualHeights';
import React, { RefObject, useRef } from 'react';

type Props = {
  className: string;
  /** The value the list's cards are drawn from */
  cardsSource: unknown;
  /** The page block whose cards decide whether the lists are equalised */
  pageRef?: RefObject<HTMLElement>;
  children?: React.ReactNode;
};

/** A list of cards whose text blocks share the tallest one's height */
const EqualHeightsList: React.FC<Props> = ({
  className,
  cardsSource,
  pageRef,
  children,
}) => {
  const listRef = useRef<HTMLDivElement>(null);

  useEqualHeights(listRef, '.ItemList01', '.TxtList01', cardsSource, pageRef);

  return (
    <div className={className} ref={listRef}>
      {children}
    </div>
  );
};

export default EqualHeightsList;
